





























import { defineComponent, PropType, ref } from '@vue/composition-api'
import CreateDialog from './CreateDialog.vue'
import IconButton from './IconButton.vue'
export default defineComponent({
  components: { IconButton, CreateDialog },
  props: {
    item: {
      type: Object as PropType<{ uuid: string }>,
      required: true,
    },
    cancelFunction: {
      type: Function as PropType<
        (uuid: string, description?: string) => Promise<void>
      >,
      required: true,
    },
  },
  setup(props, { emit }) {
    const model = ref(false)
    const loading = ref(false)
    const description = ref('')
    const onSuccess = async () => {
      loading.value = true
      try {
        await props.cancelFunction(props.item.uuid, description.value)
        emit('refresh')
        model.value = false
        description.value = ''
      } finally {
        loading.value = false
      }
    }
    const onReject = () => {
      model
    }

    return {
      description,
      onSuccess,
      onReject,
      model,
      loading,
    }
  },
})
